import { stringifyCsv } from '@neo.tax/shared';

const HEADERS = ['Name', 'Description', 'Teams (optional)', 'Launch Date (optional)'];

export const HEADERS_STRINGIFIED = stringifyCsv([HEADERS]);

export const EXAMPLE_DATA_STRINGIFIED = stringifyCsv([
  HEADERS,
  [
    'ASC Capitalization & milestones',
    'Automating capitalization status, guidance, and start/end for ASC projects',
    'Platform;Tax Engine',
    '2026-01-15',
  ],
  [
    'ASC UI improvements',
    'Improve ui speed, add more flexible views, expand reporting offerings',
    'Frontend;Design',
    '2026-02-01',
  ],
  [
    'R&D Project Clustering',
    'Generate more accurate R&D projects. Main pieces: Project naming, Data Cleanup Epic, RD Infra Reliability, Narrative Model Endpoint 2.0',
    'ML;Backend',
    '2026-03-10',
  ],
]);
